import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useProtectedRoute } from './ProtectedRoute.hook';

export const ProtectedRoute: React.FC = () => {
  const { token } = useProtectedRoute();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
